import React, { Children } from 'react'
import {
  Beta,
  IconChevronLeftDefault,
  IconChevronRightDefault,
} from '../../components'
import { CarouselProps } from './Carousel'

export type CarouselModernProps = {
  title: React.ReactNode
  noPages?: boolean
  arrowCls?: string
  arrowSize?: 'sm' | 'md' | 'lg' | 'scale-8' | number
  rightArrowCls?: string
  leftArrowCls?: string
  pagesCls?: string
  autoScrollRate?: number
} & CarouselProps &
  React.ComponentProps<typeof Beta.CarouselContent>

export const CarouselModern = ({
  title,
  srLabel,
  noPages,
  children,
  arrowCls = '',
  arrowSize = 'md',
  rightArrowCls = '',
  leftArrowCls = '',
  pagesCls = '',
  loops,
  autoScrollRate,
  scrollCount,
  onClickNext,
  onClickPrev,
  ...props
}: CarouselModernProps) => (
  <Beta.Carousel
    srLabel={srLabel}
    loops={loops}
    scrollCount={scrollCount}
    onClickNext={onClickNext}
    onClickPrev={onClickPrev}
    {...props}
  >
    {autoScrollRate && <Beta.AutoScroll rate={autoScrollRate} />}
    <div className='row small-gutters justify-content-end align-items-center'>
      <div className='col'>{title}</div>

      <div className='d-flex'>
        <div className={`col-auto ${arrowCls} ${leftArrowCls}`}>
          <Beta.CarouselPrevious kind='secondary' size='xs' symmetrical rounded>
            <IconChevronLeftDefault size={arrowSize} />
          </Beta.CarouselPrevious>
        </div>

        <div className={`col-auto ${arrowCls} ${rightArrowCls}`}>
          <Beta.CarouselNext kind='secondary' size='xs' symmetrical rounded>
            <IconChevronRightDefault size={arrowSize} />
          </Beta.CarouselNext>
        </div>
      </div>
    </div>

    <Beta.CarouselContent {...props}>
      {Children.map(children, (child, index) => (
        <Beta.CarouselItem key={index}>{child}</Beta.CarouselItem>
      ))}
      {loops &&
        Children.map(children, (child, index) => (
          <Beta.CarouselItem key={index}>{child}</Beta.CarouselItem>
        ))}
    </Beta.CarouselContent>

    {!noPages && <Beta.CarouselPages className={pagesCls} />}
  </Beta.Carousel>
)
